
import {
  serializeQueryParams,
  sendRequestWithPromise
} from 'zoomforth_zfutils/xhr_tools.js';


import {
  API_FEED_REQUEST, 
  API_FEED_RECEIVE_SUCCESS,
  API_FEED_RECEIVE_FAILURE
} from '../const/action_types.js';


export const fetchFilteredApiFeed = (apiFeedId, { filters })=>
  (dispatch)=> {
    dispatch({
      type: API_FEED_REQUEST
    });

    const params = serializeQueryParams({
      filters: JSON.stringify(filters)
    });

    return sendRequestWithPromise({ 
      method: 'GET', 
      url: `/api/filtered_api_feeds/${apiFeedId}?${params}`
    })
      .then((data)=> {
        dispatch({
          type: API_FEED_RECEIVE_SUCCESS,
          id: apiFeedId,
          filters,
          data
        });
      })
      .catch((status, message)=> {
        dispatch({
          type: API_FEED_RECEIVE_FAILURE,
          message
        });
      });
  };

